import styles from './styles.module.scss';

interface Props {
    isActive?: boolean;
}

function Dot({ isActive }:Props) {
    return (
        <div className={`${styles.dotContainer} ${isActive ? styles.active : ''}`}>
            <div className={styles.dotBackground} />
            <div className={styles.dot} />
        </div>
    );
}
export default Dot;
